import { Component, OnInit, NgZone, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatExpansionPanel } from '@angular/material';
import { CategoriesService } from '../_services/categories.service'
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable, Subscription } from 'rxjs';
import { UserService } from '../_services/user.service';
import * as firebase from 'firebase';




@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit, OnDestroy {
    categories = [];
    collapse = false;
    isLoading = true;
    isMobile = false;
    user: any;
    input: any;
    brands: any;
    filteredItems: any;
    pageDistance = 0;
    isButton = true;
    pageLength = 1;
    subscription = new Subscription();
    subsProduct = new Subscription();
    @ViewChild(MatExpansionPanel) expansionPanel: MatExpansionPanel;
    constructor(private zone: NgZone,
        private cd: ChangeDetectorRef,
        private afs: AngularFirestore, private userService: UserService, private router: Router, private categoriesService: CategoriesService) {

        this.subscription.add(this.userService.getUser().subscribe(user => {
            this.user = user;
        }));

        this.isMobile = window.matchMedia('(max-width: 1024px)').matches;

    }

    navigate(name) {
        this.zone.run(() => this.router.navigate(['/category/' + name]))
    }
    changeTextCategory(string) {
        return string
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/\./g, '_')
            .replace(/\'/g, '')
            .replace(/\s/g, '_').toLowerCase();
    }

    searchKeyUp(event: KeyboardEvent) {

        console.log(this.input.length);
        console.log(this.brands)
        if (this.input.length == 0) {
            this.isButton = true;
            this.subsProduct = this.afs.collection('products', ref => ref.orderBy('name').limit(20)).valueChanges().subscribe(data => {
                this.brands = data;
            });

            return;

        }
        if (this.input.length > 1) {
            this.isButton = false;

            this.filteredItems = this.brands.filter(
                item => {

                    if (item.name !== undefined) {

                        return this.changeTextCategory(item.name).indexOf(this.changeTextCategory(this.input)) > -1
                    }
                });
            this.brands = this.filteredItems;
        }





    }


    ngOnInit() {
        this.subsProduct = this.afs.collection('products', ref => ref.orderBy('name').limit(20)).valueChanges().subscribe(data => {
            this.brands = data;
        });

    }
    nextBrand() {
        this.pageLength = this.pageLength + 1;
        var brands;
        this.pageDistance = this.pageDistance + 20;
        console.log(this.pageDistance)
        if (this.pageDistance === 0) {
            this.subsProduct = this.afs.collection('products', ref => ref.orderBy('name').limit(20)).valueChanges().subscribe(data => {
                this.brands = data;
            });
        }
        else {

            var first = this.afs.collection("products").ref
                .orderBy("name")
                .limit(this.pageDistance);


            first.get().then((documentSnapshots) => {
                // Get the last visible document
                var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
                console.log("last", lastVisible);

                // Construct a new query starting at this document,
                // get the next 25 cities.

                this.subsProduct = this.afs.collection('products', ref => ref.orderBy('name').startAfter(lastVisible).limit(20)).valueChanges().subscribe(data => {
                    this.brands = data;
                });
                this.cd.markForCheck();




            });
        }



    }
    ngOnDestroy() {
        if (this.subsProduct) {
            this.subsProduct.unsubscribe();
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    previousBrand() {

        this.pageLength = this.pageLength - 1;
        this.pageDistance = this.pageDistance - 20;

        if (this.pageDistance === 0 && this.pageLength > 0) {
            this.subsProduct = this.afs.collection('products', ref => ref.orderBy('name').limit(20)).valueChanges().subscribe(data => {
                this.brands = data;
            });

        }
        if (this.pageDistance < 0) {
            return;
        }
        else if (this.pageDistance > 0 && this.pageLength > 0) {


            var first = this.afs.collection("products").ref
                .orderBy("name")
                .limit(this.pageDistance);


            first.get().then((documentSnapshots) => {
                // Get the last visible document
                var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
                console.log("last", lastVisible);

                // Construct a new query starting at this document,
                // get the next 25 cities.

                this.subsProduct = this.afs.collection('products', ref => ref.orderBy('name')
                    .startAfter(lastVisible).limit(20)).valueChanges().subscribe(data => {
                        this.brands = data;
                    });
                this.cd.markForCheck();




            });
        }

    }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/products/products.component.ts